/** Merge a history page without crossing conversations or looping on a repeated server page. */
export function mergeHistoryPage(previous, incoming, chatId, size = 100) {
  if (!Array.isArray(incoming) || incoming.some((row) => Number(row.chatId) !== Number(chatId) || row.id == null)) {
    throw new Error("پاسخ پیام‌ها متعلق به این گفتگو نیست.");
  }
  const rows = new Map(previous.map((row) => [String(row.id), row]));
  let added = 0;
  for (const row of incoming) {
    if (!rows.has(String(row.id))) added++;
    rows.set(String(row.id), row);
  }
  if (incoming.length >= size && !added) throw new Error("صفحهٔ تکراری در تاریخچه دریافت شد؛ دوباره تلاش کنید.");
  return { data: [...rows.values()], hasMore: incoming.length >= size };
}
